import React, { Component } from 'react';
import {
	Button,
	Card,
	CardBody,
	CardSubtitle,
	CardText,
	CardTitle,
	Col,
	Container,
	Row,
	Carousel as RS_Carousel,
	CarouselItem,
	CarouselIndicators,
	Nav,
	NavItem,
	CardImg,
	CardHeader,
} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import WOW from 'wowjs';
import { Link, withRouter } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import TestimonialCarousel from '../components/TestimonialCarousel';

// Import Assets
import {
	ArticleImg,
	FutureMessage,
	FutureMessageBg,
	HeroBg,
	HowItWorks1,
	HowItWorks2,
	HowItWorks3,
	HowItWorksBg,
	MemoraLogoSmall,
	MemoraLogoWhite,
	Memora_1r1c,
	Memora_1r2c,
	Memora_1r3c,
	Memora_2r1c,
	Memora_2r2c,
	Memora_2r3c,
	Memora_2r4c,
	Memories_1r1c,
	Memories_1r2c,
	Memories_2r,
	Memories_3r1c,
	Memories_3r2c,
	OurFeatures,
	OurPartner1,
	OurPartner2,
	OurPartner3,
	OurPartner4,
	Trump,
	Detail,
	Line,
} from '../assets';
import popular from '../assets/imgs/new/popular.png';
import rectangle from '../assets/imgs/Rectangle 105.png';
import rectangle34 from '../assets/imgs/Rectangle 13.png';
import rectangle23 from '../assets/imgs/Rectangle 23.png';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getBlogs } from '../redux/actions/blogs.action';
import moment from 'moment';

class Landing extends Component {
	state = {
		activeIndex: 0,
		activeCarouselIndex: 0,
		animating: false,
		activeTab: '1',
		activeItemIndex: 0,
		animating: false,
	};
	componentDidMount() {
		new WOW.WOW({
			live: false,
		}).init();
		if (this.props.blogs.length == 0) {
			this.props.getBlogs();
		}
	}
	responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 4,
			slidesToSlide: 3, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
			slidesToSlide: 2, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};
	setAnimating = val => {
		this.setState({ animating: val });
	};
	chevronWidth = 40;
	items = [0, 1, 2, 3, 4];
	next = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeIndex == this.items.length - 1
				? 0
				: this.state.activeIndex + 1;
		this.setState({ activeIndex: nextIndex });
	};
	prev = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeIndex == 0
				? this.items.length - 1
				: this.state.activeIndex - 1;
		this.setState({ activeIndex: nextIndex });
	};
	goToIndex = newIndex => {
		if (this.state.animating) return;
		this.setState({ activeIndex: newIndex });
	};
	slides = this.items.map(item => {
		return (
			<>
				{/* <CarouselItem
        onExiting={() => this.setState({ animating: true })}
        onExited={() => this.setState({ animating: false })}
      >
        <div
          style={{
            minHeight: "100vh",
            background: `url(${Banner})`,
            backgroundSize: "cover",
          }}
          className="d-flex"
        >
          <div className="c-i d-flex flex-column justify-content-center d-md-block">
            <h1 className="d-none d-md-block">Where memories keep living.</h1>
            <h3 className="d-none d-md-block">
              A private, safe and beautiful space to capture your story. For now
              and for future generations. Share with others or keep to yourself,
              with simple and easy to use privacy tools.
            </h3>
            <h3 className="d-block d-md-none">Where memories keep living.</h3>
            <h5 className="d-block d-md-none">
              A private, safe and beautiful space to capture your story. For now
              and for future generations. Share with others or keep to yourself,
              with simple and easy to use privacy tools.
            </h5>
            <div className="d-flex">
              <Button className="mr-2">Start Now</Button>
              <Button>Watch Our Videos</Button>
            </div>
          </div>
        </div>
      </CarouselItem>
     */}
			</>
		);
	});
	toggle = id => {
		this.setState({ activeTab: id });
	};
	setActiveIndex(idx) {
		this.setState({
			activeCarouselIndex: idx,
		});
	}
	next = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeCarouselIndex === new Array(4).fill(1).length - 1
				? 0
				: this.state.activeCarouselIndex + 1;
		this.setActiveIndex(nextIndex);
	};

	previous = () => {
		if (this.state.animating) return;
		const nextIndex =
			this.state.activeCarouselIndex === 0
				? new Array(4).fill(1).length - 1
				: this.state.activeCarouselIndex - 1;
		this.setActiveIndex(nextIndex);
	};

	goToIndex = newIndex => {
		if (this.state.animating) return;
		this.setActiveIndex(newIndex);
	};
	render() {
		let { blogs } = this.props;
		return (
			<>
				<div
					id='hero'
					className='hero'
					style={{ background: `url(${HeroBg})` }}
				>
					<RS_Carousel
						activeIndex={this.state.activeCarouselIndex}
						next={this.next}
						previous={this.previous}
					>
						<CarouselIndicators
							items={new Array(4).fill(1)}
							activeIndex={this.state.activeCarouselIndex}
							onClickHandler={this.goToIndex}
						/>
						{new Array(4).fill(1).map(() => (
							<CarouselItem
								onExiting={() => this.setAnimating(true)}
								onExited={() => this.setAnimating(false)}
							>
								<Container className='d-flex text-white h-100 align-items-center justify-content-center text-center'>
									<div>
										<h1
											className='text-uppercase text-light carousel-title'
											style={{
												wordSpacing: 8,
												fontFamily: 'ogg',
												fontWeight: 400,
											}}
										>
											Make memories a{' '}
											<br className='d-none d-md-block' />
											portable magic
										</h1>
										<p className='mt-5'>
											Capture enchanting moments and keep
											your loved ones close forever. With
											Memora,
											<br className='d-none d-md-block' />
											you always have a safe place to
											store memories and honor your loved
											ones.
										</p>
										<div className='play-btn'>
											<i className='fa fa-play'></i>
										</div>
									</div>
								</Container>
							</CarouselItem>
						))}
					</RS_Carousel>
				</div>
				<div id='memora'>
					<Row noGutters>
						<Col md='3'>
							<Row noGutters>
								<Col>
									<img
										src={Memora_1r1c}
										className='memora-img w-100'
									/>
								</Col>
							</Row>
							<Row noGutters>
								<Col xs='6'>
									<img
										src={Memora_2r1c}
										className='memora-img w-100'
									/>
								</Col>
								<Col xs='6'>
									<img
										src={Memora_2r2c}
										className='memora-img w-100'
									/>
								</Col>
							</Row>
						</Col>
						<Col md='6'>
							<div
								className='text-center text-white py-5 py-md-3 p-3  h-100 d-flex align-items-center justify-content-center'
								style={{ background: '#D93D13' }}
							>
								<div>
									<h1
										className='m-0 text-white'
										style={{
											fontSize: 52,
											fontFamily: 'Ogg',
										}}
									>
										Memora
									</h1>
									<div className='mt-3 logo-small'>
										<img src={MemoraLogoSmall} />
									</div>
									<p className='mt-5 mb-0'>
										Capture enchanting moments and keep your
										<br className='d-none d-sm-block d-md-none d-lg-block' />
										loved ones close forever. With Memora,
										you
										<br className='d-none d-sm-block d-md-none d-lg-block' />
										always have a safe place to store
										memories and
										<br className='d-none d-sm-block d-md-none d-lg-block' />
										honor your loved ones.
									</p>
								</div>
							</div>
						</Col>
						<Col md='3'>
							<Row noGutters>
								<Col xs='7'>
									<img
										src={Memora_1r2c}
										className='memora-img w-100'
									/>
								</Col>
								<Col xs='5'>
									<img
										src={Memora_1r3c}
										className='memora-img w-100'
									/>
								</Col>
							</Row>
							<Row noGutters>
								<Col xs='6'>
									<img
										src={Memora_2r3c}
										className='memora-img w-100'
									/>
								</Col>
								<Col xs='6'>
									<img
										src={Memora_2r4c}
										className='memora-img w-100'
									/>
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
				<div id='how-it-works' className='section-start'>
					<Container className='text-center'>
						<h1
							className='text-uppercase section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 4,
								wordSpacing: 8,
							}}
						>
							How It works
						</h1>
						<p className='mt-3 content-desc'>
							Keeping memories alive with Memora is easy as ABC.
							First, you have to create a memoir. You can create
							visual timelines within your memoir and add
							messages, photos, and videos either privately or by
							collaborating with others. You can also send future
							messages and order a beautifully printed QR code
							that displays your photos, videos, and messages
							whenever it is scanned. Open a user profile to get
							started.{' '}
						</p>
					</Container>
					<div
						className='how-it-works-bg mt-4 d-none d-md-block'
						style={{ background: `url(${HowItWorksBg})` }}
					></div>
					<div
						className='how-it-works-line'
						style={{
							backgroundImage: `url(${Line})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: '90% 70%',
							backgroundPosition: '55% 8%',
						}}
					>
						<Row
							noGutters
							className='justify-content-center mt-5 mt-md-0'
						>
							<Col xl='6' lg='8' md='10'>
								<Row noGutters>
									<Col xs='6' className='d-none d-md-block'>
										<img
											src={HowItWorks1}
											className='w-100'
										/>
									</Col>
									<Col md='6'>
										<div
											className='text-white p-4 d-flex align-items-center how-it-works-cont'
											style={{
												background: '#D93D13',
												minHeight: '14.583rem',
											}}
										>
											<span className='w-100 d-block'>
												<h3 className='text-left text-white mb-4 text-uppercase font-weight-bold'>
													1. Memoir
												</h3>
												<p>
													Create a profile of someone
													or an event to start the
													journey.
												</p>

												<img
													src={HowItWorks1}
													className='d-block d-md-none mx-auto'
													style={{ height: '300px' }}
												/>
											</span>
										</div>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row
							noGutters
							className='align-items-end position-relative'
						>
							<Col
								xs='12'
								md={{ size: 5, offset: 1 }}
								lg={{ size: 3, offset: 2 }}
							>
								<div
									className='text-white p-4 d-flex align-items-center'
									style={{
										background: '#D93D13',
										minHeight: '14.583rem',
									}}
								>
									<span className='w-100 d-block'>
										<h3 className='text-left text-white mb-4 text-uppercase font-weight-bold'>
											2. Visual timelines
										</h3>
										<p>
											Create a time-sequential photo
											montage and fill it with pictures,
											videos, and descriptive text to tell
											your unique story.
										</p>
										<img
											src={HowItWorks2}
											className='d-block d-md-none mx-auto'
											style={{
												height: '300px',
												maxWidth: '100%',
												objectFit: 'cover',
											}}
										/>
									</span>
								</div>
							</Col>
							<Col
								className='pl-md-2 pl-lg-3 pl-xl-4 d-none d-md-block'
								md='6'
								lg={{ offset: 1, size: 6 }}
							>
								<img src={HowItWorks2} className='w-100' />
							</Col>
							<img
								src={Detail}
								className='position-absolute'
								style={{
									zIndex: 0,
									top: '100%',
									left: '100%',
									width: '90%',
									right: -100,
									transform: 'translate(-100%, -55%)',
								}}
							/>
						</Row>
						<Row
							noGutters
							className='justify-content-center last-how-it-works-row'
						>
							<Col xl='7' lg='9' md='10'>
								<Row noGutters>
									<Col xs='6' className='d-none d-md-block'>
										<img
											src={HowItWorks3}
											className='w-100'
										/>
									</Col>
									<Col md='6'>
										<div
											className='text-white p-4 d-flex align-items-center how-it-works-cont'
											style={{
												background: '#D93D13',
												minHeight: '14.583rem',
											}}
										>
											<span className='d-block w-100'>
												<h3 className='text-left text-white mb-4 text-uppercase font-weight-bold'>
													3. QR Code creation
												</h3>
												<p>
													Generate & order a
													beautifully engraved and
													scannable QR code to take
													your memories or events to
													share your memories with
													everyone, or use the sticker
													back to
												</p>
												<img
													src={HowItWorks3}
													className='d-block d-md-none mx-auto'
													style={{ height: '300px' }}
												/>
											</span>
										</div>
									</Col>
								</Row>
							</Col>
						</Row>
					</div>
				</div>
				<div id='future-messages' className='section-start'>
					<h1
						className='text-uppercase text-center pb-4 section-title'
						style={{
							fontFamily: 'Ogg',
							letterSpacing: 4,
							wordSpacing: 8,
						}}
					>
						Future messages
					</h1>
					<div
						className='future-messages-bg'
						style={{
							backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(${FutureMessageBg})`,
						}}
					>
						<Container className='d-flex align-items-center'>
							<img
								src={FutureMessage}
								className='future-messages-img d-none d-md-inline-block'
							/>
							<div className='ml-2'>
								<p className='text-white'>
									Surprise your loved ones or future self
									<br className='d-none d-lg-block' /> with a
									message that gets delivered at a selected
									time
									<br className='d-none d-lg-block' /> in the
									future.
								</p>
								<Button
									className='bg-white text-dark text-uppercase font-weight-bold px-4 py-1'
									size='sm'
									onClick={() => {
										this.props.authUser &&
										this.props.authUser.id
											? this.props.history.push(
													'/dashboard/future-messages'
											  )
											: this.props.history.push(
													'/dashboard/register'
											  );
									}}
								>
									Start now
								</Button>
							</div>
						</Container>
					</div>
				</div>
				<div
					id='make-memories-that-keep-on-living'
					className='section-start'
				>
					<Container className='text-center'>
						<h1
							className='text-uppercase text-left section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Make memories that keep <br />
							on living
						</h1>
						<p className='text-left'>
							Keep your memories safe and share them with loved
							ones. Create,
							<br />
							collaborate, and share for the most rewarding
							experience.
						</p>
					</Container>

					<Row
						noGutters
						className='mt-5 d-flex justify-content-center'
					>
						<Col lg='12' xl='10'>
							<Row noGutters className='justify-content-center'>
								<Col lg='8' md='8' className=''>
									<img
										src={rectangle}
										className='w-100 landing-mark-an-event-img'
										style={{
											// height: '330px',
											objectFit: 'cover',
											objectPosition: 'center top',
										}}
									></img>
								</Col>

								<Col lg='4' md='8'>
									<div className='landing__card-border h-100'>
										<div
											style={{
												background: '#D93D13',
											}}
											className='p-4'
										>
											<h3 className='text-white font-weight-bold ml-3'>
												Mark an <br /> event
											</h3>
										</div>

										<p className='m-0 p-5'>
											Just completed a marathon or
											celebrated a birthday? Keep precious
											memories frozen in time and invite
											your friends to share them with you!
										</p>
									</div>
								</Col>
							</Row>
							<Row
								noGutters
								className='mt-4 justify-content-center'
							>
								<Col lg='8' md='8'>
									<img
										src={rectangle23}
										className='w-100 landing-leave-your-mark-img'
										style={{
											// height: '330px',
											objectFit: 'cover',
											objectPosition: 'center top',
										}}
									></img>
								</Col>
								<Col md='8' lg='4'>
									<div className='h-100 landing__card-border'>
										<div
											style={{
												background: '#D93D13',
											}}
											className='p-4'
										>
											<h3 className='text-white font-weight-bold ml-3'>
												Leave your <br /> mark
											</h3>
										</div>

										<p className='m-0 p-5 h-100'>
											Give your loved ones something to
											cherish by creating timelines and
											sending them messages that outlive
											you.
										</p>
									</div>
								</Col>
							</Row>
							<Row
								noGutters
								className='mt-4 justify-content-center'
							>
								<Col md='8' lg='8'>
									<img
										src={rectangle34}
										className='w-100 landing-honor-a-loved-one-img'
										style={{
											// height: '315px',
											objectFit: 'cover',
											objectPosition: 'center top',
										}}
									></img>
								</Col>

								<Col md='8' lg='4' className=''>
									<div className='d-flex landing__card-border  justify-content-center h-100'>
										<div>
											<div
												style={{
													background: '#D93D13',
												}}
												className='p-4'
											>
												<h3 className='text-white font-weight-bold ml-3'>
													Honor a <br /> loved one
												</h3>
											</div>

											<p className='m-0 p-5 h-100'>
												Give your friends and family a
												safe place to convene and share
												comfort, stories, memories,
												photos, and videos in honor of
												the departed.
											</p>
										</div>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
				<div id='our-features' className='section-start'>
					<Container className='text-center'>
						<h1
							className='text-uppercase section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Our features
						</h1>
						<p style={{ marginBottom: 130 }}>
							Explore the amazing features that set us apart and
							define our brand
						</p>
						<RS_Carousel
							activeIndex={this.state.activeCarouselIndex}
							next={this.next}
							previous={this.previous}
						>
							<CarouselIndicators
								items={new Array(4).fill(1)}
								activeIndex={this.state.activeCarouselIndex}
								onClickHandler={this.goToIndex}
								className='c-i-f'
							/>
							{new Array(4).fill(1).map(() => (
								<CarouselItem
									onExiting={() => this.setAnimating(true)}
									onExited={() => this.setAnimating(false)}
								>
									<div className='feature'>
										<Row noGutters>
											<Col md='6'>
												<img
													src={OurFeatures}
													className='w-100 h-100'
													style={{
														objectFit: 'cover',
													}}
												/>
											</Col>
											<Col md='6'>
												<div
													className='p-5 text-left h-100 d-flex align-items-center'
													style={{
														border: '1px solid #000000',
													}}
												>
													<div>
														<h3 className='font-weight-bold text-uppercase'>
															Showcase your unique
															story on a visual
															timeline
														</h3>
														<h5 className='mt-4'>
															The visual timeline
															feature lets you
															share, collaborate,
															and mark milestones.
														</h5>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</CarouselItem>
							))}
						</RS_Carousel>
					</Container>
					<div className='d-flex justify-content-center mt-4'>
						<Button
							className='btn-outline landing-btn px-4 landing-btn'
							onClick={() => {
								this.props.authUser && this.props.authUser.id
									? this.props.history.push(
											'/dashboard/future-messages'
									  )
									: this.props.history.push(
											'/dashboard/register'
									  );
							}}
						>
							Start Now
						</Button>
					</div>
				</div>
				<div id='our-partners' className='section-start'>
					<Container className='text-center'>
						<h1
							className='text-uppercase section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Our partners
						</h1>
						<p className='content-desc text-left'>
							We have received a number of notable mentions from
							our partners who have collaborated with us to raise
							awareness with the intent of ensuring that everybody
							has a safe place to cherish memories and venerate
							their loved ones.
						</p>
						<Carousel
							responsive={this.responsive}
							showDots={true}
							removeArrowOnDeviceType={[
								'desktop',
								'tablet',
								'mobile',
							]}
							infinite={true}
							autoPlay={true}
							autoPlaySpeed={3000}
						>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner1} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner2} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner3} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner4} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner1} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner2} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner3} className='w-100' />
							</div>
							<div
								className='d-flex p-4 align-items-center justify-content-center h-100'
								style={{ maxWidht: '95%' }}
							>
								<img src={OurPartner4} className='w-100' />
							</div>
						</Carousel>
					</Container>
				</div>
				<div
					id='a-membership-plan-for-everyone'
					className='section-start'
				>
					<Container className='text-center'>
						<h1
							className='text-uppercase section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							A membership plan <br />
							for everyone
						</h1>
						<p>
							We offer a range of plans to fit your priorities and
							pocket
						</p>
						<div className='row mt-lg-5 pt-lg-5'>
							<Col lg='4' className='mb-3 mb-lg-0'>
								<Card className='pricing'>
									<CardBody className='p-2'>
										<CardTitle
											tag='h3'
											className='text-center font-weight-bold'
										>
											Free Plan
										</CardTitle>
										<CardSubtitle
											tag='small'
											className='mb-4 text-center d-block'
										>
											So everyone can capture their story
										</CardSubtitle>
										<CardText className='text-left text-center mt-3 font-weight-bold'>
											<h1
												className='font-weight-bold'
												style={{
													lineHeight: '18px',
												}}
											>
												$0
												<br />
												<small
													className='ml-1'
													style={{
														fontSize: '12px',
													}}
												>
													per month
												</small>
											</h1>
										</CardText>

										<ul className='items'>
											<li>
												<i className='fa fa-check mr-2'></i>
												10GB Bandwidth Internet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Business & Financ Analysing
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												25 Social Media Reviews
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Customer Managemet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												24/7 Support
											</li>
										</ul>
										<Button
											className='btn-outline landing-btn'
											style={{
												fontSize: 18,
												minWidth: 'auto',
												width: 'calc(100% - 40px)',
												margin: '0px 20px',
											}}
											onClick={() =>
												this.props.history.push(
													'/dashboard/register'
												)
											}
										>
											Get Started
										</Button>
									</CardBody>
								</Card>
							</Col>
							<Col lg='4' className='mb-3 mb-lg-0'>
								<Card className='pricing position-relative popular'>
									<div
										className='popular position-absolute'
										style={{
											top: 15,
											left: -5,
											height: 30,
										}}
									>
										<img src={popular} />
										<div
											className='position-absolute'
											style={{
												top: '50%',
												left: '50%',
												transform:
													'translate(-50%,-50%)',
											}}
										>
											<small>Popular</small>
										</div>
									</div>
									<CardBody className='p-2'>
										<CardTitle
											tag='h3'
											className='text-center text-white font-weight-bold mt-5'
										>
											Advance Plan
										</CardTitle>
										<CardSubtitle
											tag='small'
											className='mb-4 text-center d-block'
										>
											So everyone can capture their story
										</CardSubtitle>
										<CardText className='text-left text-center mt-3 font-weight-bold'>
											<h1
												className='font-weight-bold text-white'
												style={{
													lineHeight: '18px',
												}}
											>
												$39.9
												<br />
												<small
													className='ml-1'
													style={{
														fontSize: '12px',
													}}
												>
													per month
												</small>
											</h1>
										</CardText>

										<ul className='items'>
											<li>
												<i className='fa fa-check mr-2'></i>
												10GB Bandwidth Internet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Business & Financ Analysing
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												25 Social Media Reviews
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Customer Managemet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												24/7 Support
											</li>
										</ul>
										<Button
											className='btn-outline landing-btn'
											style={{
												fontSize: 18,
												minWidth: 'auto',
												width: 'calc(100% - 40px)',
												margin: '0px 20px',
											}}
											onClick={() =>
												this.props.history.push(
													'/dashboard/register'
												)
											}
										>
											Get Started
										</Button>
									</CardBody>
								</Card>
							</Col>
							<Col lg='4'>
								<Card className='pricing'>
									<CardBody className='p-2'>
										<CardTitle
											tag='h3'
											className='text-center font-weight-bold'
										>
											Premium Plan
										</CardTitle>
										<CardSubtitle
											tag='small'
											className='mb-4 text-center d-block'
										>
											So everyone can capture their story
										</CardSubtitle>
										<CardText className='text-left text-center mt-3 font-weight-bold'>
											<h1
												className='font-weight-bold'
												style={{
													lineHeight: '18px',
												}}
											>
												$99.9
												<br />
												<small
													className='ml-1'
													style={{
														fontSize: '12px',
													}}
												>
													per month
												</small>
											</h1>
										</CardText>
										<ul className='items'>
											<li>
												<i className='fa fa-check mr-2'></i>
												10GB Bandwidth Internet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Business & Financ Analysing
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												25 Social Media Reviews
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												Customer Managemet
											</li>
											<li>
												<i className='fa fa-check mr-2'></i>
												24/7 Support
											</li>
										</ul>
										<Button
											className='btn-outline landing-btn'
											style={{
												fontSize: 18,
												minWidth: 'auto',
												width: 'calc(100% - 40px)',
												margin: '0px 20px',
											}}
											onClick={() =>
												this.props.history.push(
													'/dashboard/register'
												)
											}
										>
											Get Started
										</Button>
									</CardBody>
								</Card>
							</Col>
						</div>
					</Container>
				</div>
				<div
					id='articles-you-may-be-interested-in'
					className='section-start'
				>
					<Container className='text-center'>
						<h1
							className='text-uppercase section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Articles you may be
							<br />
							interested in
						</h1>
						<Row className='mt-4'>
							{blogs.length > 0 &&
								blogs.slice(0, 4).map((blog, idx) => (
									<Col
										md='6'
										lg='4'
										xl='4'
										className='text-left mb-5'
									>
										<Link to={`/main/blog/${blog.id}`}>
											<img
												src={
													blog.cover_images.length >
														0 &&
													blog.cover_images[0]
												}
												className='w-100 mb-4'
												style={{
													height: '200px',
													objectFit: 'contain',
												}}
											/>
											<small className='text-muted'>
												{moment
													.unix(
														blog.created_at.seconds
													)
													.format('DD MMMM YYYY')}
											</small>
											<h5
												className='text-uppercase'
												style={{
													fontFamily: 'Ogg',
													letterSpacing: 6,
												}}
											>
												{blog.title}
											</h5>
											<p className='mt-4'>
												<div
													dangerouslySetInnerHTML={{
														__html:
															blog.desc.length >
															100
																? blog.desc.substr(
																		0,
																		100
																  ) + '......'
																: blog.desc,
													}}
												></div>
												{/* Send messages to loved ones weeks, months and years into the
                  future. It's your modern-day time capsule. */}
											</p>
										</Link>
									</Col>
								))}
						</Row>
						<div className='d-flex justify-content-center mt-4'>
							<Link to='/main/blog'>
								<Button className='btn-outline landing-btn'>
									More Articles
								</Button>
							</Link>
						</div>
					</Container>
				</div>
				<div
					id='heres-what-our-users-are-saying'
					className='section-start'
				>
					<Container>
						<h1
							className='text-uppercase text-center section-title'
							style={{
								fontFamily: 'Ogg',
								letterSpacing: 6,
								wordSpacing: 8,
							}}
						>
							Here’s what our <br />
							users are saying
						</h1>
						<div className='mb-4'>
							<TestimonialCarousel />
						</div>
					</Container>
				</div>
			</>
		);
	}
}
export function mapStateToProps(state) {
	return {
		blogs: state.blogs.blogs,
		authUser: state.authUser,
	};
}
export function mapDispatchToProps(dispatch) {
	return {
		getBlogs: () => dispatch(getBlogs()),
	};
}
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Landing)
);
